/* Recommandations produits — chargées via la Product Recommendations API */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-lf-reco][data-url]').forEach(function (el) {
      if (el.dataset.lfRecoDone) return;
      el.dataset.lfRecoDone = '1';
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var inner = doc.querySelector('.lf-reco__inner');
          if (inner) el.innerHTML = inner.outerHTML;
        })
        .catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
